var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationBusWaltti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2006 28H2.8004C1.25351 28 0 26.7465 0 25.2006V2.8004C0 1.25351 1.25351 0 2.8004 0H25.2006C26.7475 0 28.001 1.25351 28.001 2.8004V25.2006C28 26.7465 26.7465 28 25.2006 28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0874 2.80038H6.91358C6.13124 2.80038 5.49609 3.43455 5.49609 4.21787V21.2267C5.49609 22.009 6.13026 22.6442 6.91358 22.6442H21.0874C21.8698 22.6442 22.5049 22.01 22.5049 21.2267V4.21787C22.5039 3.43455 21.8698 2.80038 21.0874 2.80038ZM10.8499 4.06674H17.1501V5.13355H10.8499V4.06674ZM7.99818 20.1036C7.39858 20.1036 6.91358 19.6176 6.91358 19.019C6.91358 18.4194 7.39957 17.9344 7.99818 17.9344C8.59777 17.9344 9.08277 18.4204 9.08277 19.019C9.08376 19.6176 8.59777 20.1036 7.99818 20.1036ZM20.0018 20.1036C19.4023 20.1036 18.9172 19.6176 18.9172 19.019C18.9172 18.4194 19.4032 17.9344 20.0018 17.9344C20.6014 17.9344 21.0864 18.4204 21.0864 19.019C21.0874 19.6176 20.6014 20.1036 20.0018 20.1036ZM21.0874 14.4405C21.0874 14.6974 20.9156 14.9216 20.6676 14.9878C19.6798 15.2535 17.0592 15.8689 14 15.8689C10.9408 15.8689 8.3202 15.2535 7.3324 14.9878C7.08447 14.9216 6.91259 14.6974 6.91259 14.4405V6.75946C6.91259 6.44633 7.16645 6.19247 7.47958 6.19247H20.5194C20.8326 6.19247 21.0864 6.44633 21.0864 6.75946V14.4405H21.0874Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08376 22.6195H6.91357V25.2006H9.08376V22.6195Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0874 22.6195H18.9172V25.2006H21.0874V22.6195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationBusWaltti);
export default __webpack_public_path__ + "static/media/station-bus-waltti.9591618ea07337807294e9520a92c5bf.svg";
export { ForwardRef as ReactComponent };